var app = angular.module('leonardo');

var WidgetTemplatePermanence = function(TemplateService, $rootScope) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/template-permanence.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      recurrenceType: '=',
      noResults: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.no_results = scope.noResults ? scope.noResults : 'No permanence';

      scope.options = [];
      scope.data = {
        value: null
      };

      scope.setOptions = function() {
        if (scope.recurrenceType && !isNull(scope.recurrenceType.type)) {
          switch (scope.recurrenceType.type.toString()) {
            case TemplateService.RECURRENCE_DAILY:
            case TemplateService.RECURRENCE_WEEKLY:
            case TemplateService.RECURRENCE_FIXED_DATE:
              scope.options = [
                {
                  value: 1,
                  label: '1 day'
                },
                {
                  value: 2,
                  label: '2 days'
                },
                {
                  value: 3,
                  label: '3 days'
                },
                {
                  value: 4,
                  label: '4 days'
                },
                {
                  value: 5,
                  label: '5 days'
                }
              ];
              break;
            case TemplateService.RECURRENCE_MONTHLY:
              scope.options = [
                {
                  value: 1,
                  label: '1 week'
                },
                {
                  value: 2,
                  label: '2 weeks'
                },
                {
                  value: 3,
                  label: '3 weeks'
                },
                {
                  value: 4,
                  label: '4 weeks'
                },
                {
                  value: 5,
                  label: '5 weeks'
                }
              ];
              break;
            case TemplateService.RECURRENCE_YEARLY:
              scope.options = [
                {
                  value: 1,
                  label: '1 month'
                },
                {
                  value: 2,
                  label: '2 months'
                },
                {
                  value: 3,
                  label: '3 months'
                },
                {
                  value: 4,
                  label: '4 months'
                },
                {
                  value: 5,
                  label: '5 months'
                },{
                  value: 6,
                  label: '6 month'
                },
                {
                  value: 7,
                  label: '7 months'
                },
                {
                  value: 8,
                  label: '8 months'
                },
                {
                  value: 9,
                  label: '9 months'
                },
                {
                  value: 10,
                  label: '10 months'
                },
                {
                  value: 11,
                  label: '11 months'
                },
                {
                  value: 12,
                  label: '12 months'
                }
              ];
              break;
          }
        }
      };

      scope.$on('recurrence:updated', function(event, data) {
        scope.recurrenceType = data;
        scope.setOptions();
      });


      scope.$watch('data.value', function(newValue, oldValue) {
        if (newValue == oldValue) {
          return;
        }
        scope.ngModelCtrl.$setViewValue(newValue);
      });

      scope.ngModelCtrl.$render = function() {
        scope.setOptions();
        scope.data.value = scope.ngModelCtrl.$modelValue;
      };
    }
  };
};

app.directive('widgetTemplatePermanence', ['TemplateService', '$rootScope', WidgetTemplatePermanence]);
